import { ComparablesFilterFields } from "../components/Filters/FiltersWithClear";

export const disabledZooplaFields = new Set<ComparablesFilterFields>([]);
export const disabledEPCFields = new Set<ComparablesFilterFields>(["bedrooms", "yearBuiltFrom", "yearBuiltTo"]);
/** US Last Sold comparables: bedrooms and year built are supported; only bedrooms disabled for EPC mode */
export const disabledEPCFieldsUS = new Set<ComparablesFilterFields>(["bedrooms"]);
